import { render, staticRenderFns } from "./Index.vue?vue&type=template&id=ff6825e2&"
import script from "./Index.vue?vue&type=script&lang=js&"
export * from "./Index.vue?vue&type=script&lang=js&"
import style0 from "./Index.vue?vue&type=style&index=0&id=ff6825e2&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)


    import installComponents from "!/Users/dhulsman/Projects/rentmagic.website.vue.defietsambassadegent/node_modules/bootstrap-vue-loader/lib/runtime/installComponents.js"
    import {BCol, BRow, BAlert, BTab, BTabs, BContainer} from 'bootstrap-vue'
    installComponents(component, {BCol, BRow, BAlert, BTab, BTabs, BContainer})
    

export default component.exports